module.exports = __webpack_public_path__ + "img/receiveTokens.1775dd06.svg";